import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import introduce from '@/components/introduce'
import login from '@/components/login'
import mycenter from '@/components/mycenter'
import editMyCenter from '@/components/editMyCenter'
import myTeam from '@/components/myTeam'
import TeamSignUp from '@/components/TeamSignUp'
import editTeam from '@/components/editTeam'
import vote from '@/components/vote'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
			redirect:'/introduce',
			children:[{
				path: '/introduce',
				name: '理财规划师大赛',
				component: introduce,
			},{
				path: '/login',
				name: '理财规划师大赛登录',
				component: login,
			},{
				path: '/mycenter',
				name: '个人信息',
				component: mycenter,
			},{
				path: '/editMyCenter',
				name: '修改个人信息',
				component: editMyCenter,
			},{
				path: '/myTeam',
				name: '我的团队',
				component: myTeam,
			},{
				path: '/TeamSignUp',
				name: '团队报名',
				component: TeamSignUp,
			},{
				path: '/editTeam',
				name: '修改团队信息',
				component: editTeam,
			},{
				path: '/vote',
				name: '理财规划师大赛投票',
				component: vote,
			}]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js